/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { _OutcomeRequestLabel } from './_outcomeRequestLabel';

/**
 * Manually set an enrollment's reply outcome.
 *
 * ``label=None`` clears the manual override and lets the AI
 * classification (if any) win again.
 */
export interface _OutcomeRequest {
  label?: _OutcomeRequestLabel;
}
